import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const emptyForm = { name: "", email: "", phone: "", city: "", budget: "", message: "" };

export const RequestForm = ({ title, subtitle, defaultMessage = "", dark = false, simParams = null }) => {
  const { t } = useLang();
  const f = t.franchise.form;
  const [form, setForm] = useState({ ...emptyForm, message: defaultMessage });
  const [loading, setLoading] = useState(false);
  const update = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/franchise-applications`, { ...form, budget: form.budget || f.budgetOptions[0], sim_params: simParams || undefined });
      toast.success(f.success);
      setForm({ ...emptyForm, message: defaultMessage });
    } catch (err) {
      toast.error(f.error);
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full rounded-xl border px-4 py-3 text-base focus:outline-none focus:ring-2 transition-[border-color,box-shadow] duration-200 " +
    (dark
      ? "border-white/15 bg-white/5 text-white placeholder-white/40 focus:border-tricolor-green focus:ring-tricolor-green/20"
      : "border-line bg-white text-ink placeholder-muted focus:border-tricolor-green focus:ring-tricolor-green/20");

  return (
    <div className={`rounded-[2rem] border p-7 md:p-10 ${dark ? "border-white/10 bg-white/[0.03]" : "border-line bg-surface"}`}>
      <h3 className={`font-display font-extrabold text-2xl md:text-3xl ${dark ? "text-white" : "text-ink"}`}>{title || t.franchise.formTitle}</h3>
      {subtitle && <p className={`mt-2 ${dark ? "text-white/60" : "text-muted"}`}>{subtitle}</p>}
      <form onSubmit={submit} className="mt-7 grid md:grid-cols-2 gap-5" data-testid="franchise-form">
        <input required value={form.name} onChange={update("name")} placeholder={f.name} className={input} data-testid="form-name" />
        <input required type="email" value={form.email} onChange={update("email")} placeholder={f.email} className={input} data-testid="form-email" />
        <input required value={form.phone} onChange={update("phone")} placeholder={f.phone} className={input} data-testid="form-phone" />
        <input required value={form.city} onChange={update("city")} placeholder={f.city} className={input} data-testid="form-city" />
        <select required value={form.budget} onChange={update("budget")} className={`${input} md:col-span-2`} data-testid="form-budget">
          <option value="" disabled>{f.budget}</option>
          {f.budgetOptions.map((o) => <option key={o} value={o} className="text-ink">{o}</option>)}
        </select>
        <textarea rows={3} value={form.message} onChange={update("message")} placeholder={f.message} className={`${input} md:col-span-2 resize-none`} data-testid="form-message" />
        <button type="submit" disabled={loading} className="btn-primary md:col-span-2 disabled:opacity-60" data-testid="form-submit">
          {loading ? f.sending : f.submit} <ArrowRight size={18} />
        </button>
      </form>
    </div>
  );
};
